import { type Language } from 'ecosystem'

export interface NshiftOverrides {
  noDeliveryOptions: string
  pickUpInStore: string
  recipientTitle: string
  deliveryOptionsTitle: string
  fieldPostalCodeLabel: string
  fieldCountryCodeLabel: string
  fieldCityLabel: string
  fieldAddressLabel: string
  errorRequired: string
  errorInvalidFormat: string
  errorInvalidPostalCode: string
  rememberOnDevice: string
}

export const nshiftCheckoutTranslations: Record<Language, NshiftOverrides> = {
  en: {
    noDeliveryOptions: 'No delivery options available.',
    pickUpInStore: 'Pick up in our store (shipping is canceled)',
    recipientTitle: 'Recipient details',
    deliveryOptionsTitle: 'Delivery options',

    fieldPostalCodeLabel: 'Postal code',
    fieldCountryCodeLabel: 'Country',
    fieldCityLabel: 'City',
    fieldAddressLabel: 'Address',

    errorRequired: 'Required',
    errorInvalidFormat: 'Invalid format',
    errorInvalidPostalCode: 'Invalid postal code',
    rememberOnDevice: 'Remember my details on this device'
  },
  no: {
    noDeliveryOptions: 'Ingen leveringsalternativer tilgjengelig.',
    pickUpInStore: 'Hent i butikken vår (frakt er kansellert)',
    recipientTitle: 'Mottakerdetaljer',
    deliveryOptionsTitle: 'Leveringsalternativer',

    fieldPostalCodeLabel: 'Postnummer',
    fieldCountryCodeLabel: 'Land',
    fieldCityLabel: 'By',
    fieldAddressLabel: 'Adresse',

    errorRequired: 'Påkrevd',
    errorInvalidFormat: 'Ugyldig format',
    errorInvalidPostalCode: 'Ugyldig postnummer',
    rememberOnDevice: 'Husk opplysningene mine på denne enheten'
  },
  de: {
    noDeliveryOptions: 'Keine Lieferoptionen verfügbar.',
    pickUpInStore: 'Abholung im Laden (Versand entfällt)',
    recipientTitle: 'Empfängerdetails',
    deliveryOptionsTitle: 'Lieferoptionen',

    fieldPostalCodeLabel: 'Postleitzahl',
    fieldCountryCodeLabel: 'Land',
    fieldCityLabel: 'Stadt',
    fieldAddressLabel: 'Adresse',

    errorRequired: 'Erforderlich',
    errorInvalidFormat: 'Ungültiges Format',
    errorInvalidPostalCode: 'Ungültige Postleitzahl',
    rememberOnDevice: 'Meine Daten auf diesem Gerät merken'
  },
  sv: {
    noDeliveryOptions: 'Inga leveransalternativ tillgängliga.',
    pickUpInStore: 'Hämta i vår butik (frakten stryks)',
    recipientTitle: 'Mottagaruppgifter',
    deliveryOptionsTitle: 'Leveransalternativ',

    fieldPostalCodeLabel: 'Postnummer',
    fieldCountryCodeLabel: 'Land',
    fieldCityLabel: 'Stad',
    fieldAddressLabel: 'Adress',

    errorRequired: 'Obligatoriskt',
    errorInvalidFormat: 'Ogiltigt format',
    errorInvalidPostalCode: 'Ogiltigt postnummer',
    rememberOnDevice: 'Kom ihåg mina uppgifter på den här enheten'
  },
  da: {
    noDeliveryOptions: 'Ingen leveringsmuligheder tilgængelige.',
    pickUpInStore: 'Afhent i vores butik (fragt annulleres)',
    recipientTitle: 'Modtageroplysninger',
    deliveryOptionsTitle: 'Leveringsmuligheder',

    fieldPostalCodeLabel: 'Postnummer',
    fieldCountryCodeLabel: 'Land',
    fieldCityLabel: 'By',
    fieldAddressLabel: 'Adresse',

    errorRequired: 'Påkrævet',
    errorInvalidFormat: 'Ugyldigt format',
    errorInvalidPostalCode: 'Ugyldigt postnummer',
    rememberOnDevice: 'Husk mine oplysninger på denne enhed'
  },
  fi: {
    noDeliveryOptions: 'Ei toimitusvaihtoehtoja saatavilla.',
    pickUpInStore: 'Nouda myymälästämme (toimitus peruttu)',
    recipientTitle: 'Vastaanottajan tiedot',
    deliveryOptionsTitle: 'Toimitusvaihtoehdot',

    fieldPostalCodeLabel: 'Postinumero',
    fieldCountryCodeLabel: 'Maa',
    fieldCityLabel: 'Kaupunki',
    fieldAddressLabel: 'Osoite',

    errorRequired: 'Pakollinen',
    errorInvalidFormat: 'Virheellinen muoto',
    errorInvalidPostalCode: 'Virheellinen postinumero',
    rememberOnDevice: 'Muista tietoni tällä laitteella'
  }
}
